import { InventoryMediaType, ServiceInventoryMediaType } from "../inventories";
import { pubCapPctToServicePubCap, servicePubCapObjectToPubCapPct } from "./utils";
export const serviceToPublisherOptimizationTemplateStatus = (status) => {
    switch (status) {
        case ServicePublisherOptimizationTemplateStatus.READY:
            return PublisherOptimizationTemplateStatus.READY;
        case ServicePublisherOptimizationTemplateStatus.ARCHIVED:
            return PublisherOptimizationTemplateStatus.ARCHIVED;
        default:
            return undefined;
    }
};
export const publisherOptimizationTemplateStatusToService = (status) => {
    switch (status) {
        case PublisherOptimizationTemplateStatus.READY:
            return ServicePublisherOptimizationTemplateStatus.READY;
        case PublisherOptimizationTemplateStatus.ARCHIVED:
            return ServicePublisherOptimizationTemplateStatus.ARCHIVED;
        default:
            return undefined;
    }
};
export const serviceToPublisherOptimizationTemplateMediaType = (mediaType) => {
    switch (mediaType) {
        case ServiceInventoryMediaType.VIDEO:
            return InventoryMediaType.VIDEO;
        case ServiceInventoryMediaType.AUDIO:
            return InventoryMediaType.AUDIO;
        case ServiceInventoryMediaType.DISPLAY:
            return InventoryMediaType.DISPLAY;
        default:
            return undefined;
    }
};
export const publisherOptimizationTemplateMediaTypeToService = (mediaType) => {
    switch (mediaType) {
        case InventoryMediaType.VIDEO:
            return ServiceInventoryMediaType.VIDEO;
        case InventoryMediaType.AUDIO:
            return ServiceInventoryMediaType.AUDIO;
        case InventoryMediaType.DISPLAY:
            return ServiceInventoryMediaType.DISPLAY;
        default:
            return undefined;
    }
};
export const servicePublisherOptimizationTemplateToPublisherOptimizationTemplate = (settings) => {
    if (!settings?.length)
        return [];
    const pubArray = Array.isArray(settings) ? settings : [settings];
    return pubArray.map((pub) => ({
        publisherId: pub?.pub_id,
        publisherName: pub?.pub_name,
        pubCapPct: servicePubCapObjectToPubCapPct(pub?.pub_cap),
        bundleRules: pub?.bundle_rules?.map((rule) => ({
            id: rule.id,
            excluded: rule.excluded
        })) || [],
        channelRules: pub?.channel_rules?.map((rule) => ({
            name: rule.name,
            excluded: rule.excluded
        })) || [],
        includedBundles: [],
        includedChannels: []
    }));
};
export const publisherOptimizationTemplateToServicePublishersOptimizationTemplate = (settings) => {
    if (!settings?.length)
        return [];
    const pubArray = Array.isArray(settings) ? settings : [settings];
    return pubArray.map((pub) => {
        const servicePubCapPct = pubCapPctToServicePubCap(pub.pubCapPct);
        const pub_cap = servicePubCapPct !== undefined ? { pub_cap_pct: servicePubCapPct } : undefined;
        return {
            pub_id: pub.publisherId,
            pub_name: pub.publisherName,
            ...(pub_cap ? { pub_cap } : {}), // does not send pub_cap {} to BE if undefined
            bundle_rules: pub?.bundleRules?.map((rule) => ({
                id: rule.id,
                excluded: rule.excluded || false
            })) || [],
            channel_rules: pub?.channelRules?.map((rule) => ({
                name: rule.name,
                excluded: rule.excluded || false
            })) || []
        };
    });
};
export var ServicePublisherOptimizationTemplateStatus;
(function (ServicePublisherOptimizationTemplateStatus) {
    ServicePublisherOptimizationTemplateStatus[ServicePublisherOptimizationTemplateStatus["READY"] = 200] = "READY";
    ServicePublisherOptimizationTemplateStatus[ServicePublisherOptimizationTemplateStatus["ARCHIVED"] = 500] = "ARCHIVED";
})(ServicePublisherOptimizationTemplateStatus || (ServicePublisherOptimizationTemplateStatus = {}));
export var PublisherOptimizationTemplateStatus;
(function (PublisherOptimizationTemplateStatus) {
    PublisherOptimizationTemplateStatus["READY"] = "Ready";
    PublisherOptimizationTemplateStatus["ARCHIVED"] = "Archived";
})(PublisherOptimizationTemplateStatus || (PublisherOptimizationTemplateStatus = {}));
export const serviceToPublisherOptimizationTemplate = (base) => {
    const { id, name, status: TemplateStatus, updated_at: { seconds: updated } = { seconds: 0 } } = base;
    const status = serviceToPublisherOptimizationTemplateStatus(TemplateStatus);
    const mediaType = serviceToPublisherOptimizationTemplateMediaType(base.media_type);
    const publishers = servicePublisherOptimizationTemplateToPublisherOptimizationTemplate(base.pub_settings);
    return {
        id,
        name,
        ...("updated_at" in base && { updatedAt: new Date(updated * 1000) }),
        ...("status" in base && { status }),
        ...("media_type" in base && { mediaType }),
        ...("pub_settings" in base && { publisherSettings: publishers })
    };
};
export const publisherOptimizationTemplateToService = (base) => {
    const { id, name, status: TemplateStatus, updatedAt } = base;
    const status = publisherOptimizationTemplateStatusToService(TemplateStatus);
    const mediaType = publisherOptimizationTemplateMediaTypeToService(base.mediaType);
    const publishers = publisherOptimizationTemplateToServicePublishersOptimizationTemplate(base.publisherSettings);
    return {
        id,
        name,
        ...("status" in base && { status }),
        ...("mediaType" in base && { media_type: mediaType }),
        ...("publisherSettings" in base && { pub_settings: publishers }),
        ...(updatedAt ? { updated_at: { seconds: Math.floor(updatedAt.getTime() / 1000) } } : {})
    };
};
//# sourceMappingURL=optimizationTemplate.js.map